import { Vector3 } from "three";

export const ControlConstants = {
  // speed constants
  // THESE ARE FOR DRAGGING WITH THE MOUSE
  MOVEMENT_SPEED: 1.5, // meters/second.
  ROTATION_SPEED: 0.005, // radians/second for dragging
  SPEED_MULTIPLIER: 1,
  SCROLL_SPEED: 3.74 * 0.5 * 0.001,
  PINCH_SPEED: 0.008,
  TWO_FINGER_SLIDE_SPEED: 0.008,
  BURST_DURATION: 800, // ms

  // Easing/lerp speeds
  FOV_LERP_SPEED: 100, // deg/sec toward target FOV
  // ROLL_MAX_DEG: 25, // max absolute roll angle
  // ROLL_LERP_SPEED: 180, // deg/sec toward target roll

  // speed constants
  // THESE ARE FOR MOVING WITH THE JOYSTICK joystick constants
  JOYSTICK_SENSITIVITY: 1.0,
  JOYSTICK_DEADZONE_RADIUS: 1e-6,
  JOYSTICK_EASING: 1,

  // ARROW KEY LOOK
  LOOK_JOYSTICK_SPEED: .8,
  LOOK_JOYSTICK_EASING: 1.0,
  VERTICAL_LOOK_SENSITIVITY: 1.0,


  // physics constants
  PAN_FRICTION: 0.93,
  PAN_INERTIA: 0.17,
  PINCH_INERTIA: 0.15,
  MOVE_INERTIA: 0.17,

  BURST_SCROLL_DELTA: 2415,


  MovementScheme: {
    WASD_RF: "wasd_rf",
    WASD_SPACE_CTRL: "wasd_space_ctrl",
  } as const,

  // key mappings
  WASD_KEYCODE_MOVE: {
    KeyW: new Vector3(0, 0, -1),
    KeyS: new Vector3(0, 0, 1),
    KeyA: new Vector3(-1, 0, 0),
    KeyD: new Vector3(1, 0, 0),
  },
  RF_KEYCODE_MOVE: {
    KeyR: new Vector3(0, 1, 0),
    KeyF: new Vector3(0, -1, 0),
  },
  SPACE_CTRL_KEYCODE_MOVE: {
    Space: new Vector3(0, 1, 0),
    ControlLeft: new Vector3(0, -1, 0),
  },
  ARROW_KEYCODE_MOVE: {
    ArrowUp: new Vector3(0, 0, -1),
    ArrowDown: new Vector3(0, 0, 1),
    ArrowLeft: new Vector3(-1, 0, 0),
    ArrowRight: new Vector3(1, 0, 0),
    // PageUp: new Vector3(0, 1, 0),
    // PageDown: new Vector3(0, -1, 0),
  },
  // field of view adjustment
  FOV_MIN_DEG: 65,
  FOV_MAX_DEG: 100,
  FOV_DELTA_DEG: 20,
  FOV_EASE_DURATION_MS: 250,

  // physics
  GRAVITY_ACCELERATION: 9.81,
  JUMP_IMPULSE: 3.2,
} as const;

export type MovementScheme =
  (typeof ControlConstants.MovementScheme)[keyof typeof ControlConstants.MovementScheme];
